import { useCallback } from 'react';
import { useUpdateParentIdMutation } from './useGroupOperationsMutation';
import { showToast, TOAST_SUCCESS, FIVE_SECONDS } from 'lib/utils';

export const useAddToGroup = (locationId: string) => {
  const updateParentIdMutation = useUpdateParentIdMutation(locationId);

  const addToGroup = useCallback(
    async (requestId: string, groupId: string) => {
      if (!locationId) return;
      await updateParentIdMutation.mutateAsync({
        requestId,
        parentId: groupId,
      });
      showToast('1 item added/updated to group', TOAST_SUCCESS, FIVE_SECONDS);
    },
    [updateParentIdMutation, locationId]
  );

  return { addToGroup };
};
